module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "c6",
    attrs: {
      "id": "calibre_pb_3"
    }
  }, [_c('span', {
    staticClass: "c4"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "western1"
  }, [_vm._v("I would like to express my sincere gratitude\nto some people who played a part in helping me tell this story and\nget it out into the world. First, to my parents, Paul and Theresa,\nfor their guidance and sacrifices that got me through those\nharrowing formative years and whose influence shapes me still. To\nNicki and Sam, whose courage, strength, and love are enduring\ninspirations. To my wife, Heather, for her support even on those\nlonely nights when she surely wondered why she had committed\nherself to such a recluse. To Bruce Watson, teacher and friend, who\ninstilled in me a deeper appreciation for the art form of\nstorytelling and who read a very early draft of this novel and held\nnothing back. To my other advance readers who saw the things I\ncouldn't. To Craig DiLouie who offered the advice and guidance to\nplant this story's seed in the ground. To Felicia Sullivan, who\nrevealed my weaknesses to me with her edits. And to the good people\nat Permuted Press, especially Michael Wilson and Anthony Ziccardi,\nwho were willing to take a risk.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1209b1c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_403fa671f87995d2e5aedda9ecddad25_61bGyM.ch.fixed.fc.tidied.stylehacked.xfixed_split_004.vue
// module id = 69
// module chunks = 0